function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10{fill:#fcd0be;}.cls-2{fill:#fbc4a8;}.cls-3{fill:url(#Degradado_sin_nombre_10);}.cls-4{fill:#d8e2e7;}.cls-5{fill:#fff;}.cls-6{fill:#414042;}.cls-7{fill:#e2ecf1;}.cls-8{fill:none;}.cls-10,.cls-8{stroke:#414042;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.43px;}.cls-9{fill:url(#Degradado_sin_nombre_17);}.cls-11{fill:#f8abac;}"), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_10",
  x1: 14559.49,
  y1: 39.65,
  x2: 14678.45,
  y2: 39.65,
  gradientTransform: "matrix(-1, 0, 0, 1, 14707.72, 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ea4630"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e81e25"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "Degradado_sin_nombre_17",
  x1: 14572.36,
  y1: 62.89,
  x2: 14687.85,
  y2: 62.89,
  gradientTransform: "matrix(-1, 0, 0, 1, 14707.72, 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e2ecf1"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M119.79,110a10.61,10.61,0,1,0,10.6-10.61A10.6,10.6,0,0,0,119.79,110Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M4.29,88.14a10.61,10.61,0,1,0,10.6-10.61A10.61,10.61,0,0,0,4.29,88.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M123.32,79.3c0-4.3,9.84-4.45,8.61-30.89,10.45,17.22,12.91,28.28,12.91,28.28S163.28,26.28,114.1,6,41.56,20.9,29.26,52.25C84,63.93,123.32,79.3,123.32,79.3Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M127,78.69s9.84,43.64-19.05,58.4c-46.73,7.38-75.62,2.46-87.3-9.22s-6.15-55.33,9.22-70.7S119.64,54.71,127,78.69Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M107.34,95.52S108,99,106,99.66,100,92.29,88.21,90c-3.92,0-2.31-9,3-6.45S104.8,90.44,107.34,95.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M40.21,76.59s-2.68,2.29-1.47,4.12S48,78.59,58.69,84c3.09,2.42,7.35-5.66,1.61-6.93S45.33,74.15,40.21,76.59Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M82,102.55a10,10,0,1,0,10-10A10,10,0,0,0,82,102.55Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M85.67,102.78a7.73,7.73,0,1,0,7.72-7.73A7.72,7.72,0,0,0,85.67,102.78Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M37.26,91.71a10,10,0,1,0,10-10A10,10,0,0,0,37.26,91.71Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M41,91.94a7.72,7.72,0,1,0,7.72-7.72A7.71,7.71,0,0,0,41,91.94Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M84.75,74.08s13.83,26.28,35,24c1.38,5.53,2.3,17.06,2.3,17.06l2.77,2.77s6.92-18.91,2.31-35.51C116.56,67.16,84.75,74.08,84.75,74.08Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M76,66.24S37,90.44,16.51,81.91c2.3-11.52,13.37-24.74,13.37-24.74S61.23,48.72,76,66.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M62.85,62.78S40.72,84.45,24.58,77.53"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M52.47,63.7S35.41,77.3,24.12,70.85"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M129.47,89.44C126.89,90.52,57,58.79,21.73,68.54c-2.86-5.32-1.95-12.12-.47-18.4A18,18,0,0,1,39.13,36.3c25.89.56,82.44,4.41,92.8,27C136.85,71.92,136.85,86.37,129.47,89.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M155,75.15c4.91-8-3.08-6.76-4.31-4.91,1.54-6.46-4.92-6.46-5.84-2.77-.92-4-9.53-3.38-6.15,4.92-3.68-1.23-4,5.22-.61,5.84-2.46,5.53.61,8.91,3.38,5.84,0,9.22,7.38,2.77,6.76-.31,5.54,4.92,7.07-.31,5.23-4.61C159.29,81,159,76.08,155,75.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M126,115.57s1.65,15.22-3.89,14.76c9.46,18.44-4.61,23.51-9.68,22.13,7.84,20.75-22.59,31.12-28.58,21.9C77.37,190.5,52,184.73,52.47,172.75,46,188,18.81,182.43,24.35,164.91c-9.22,5.07-22.6-8.3-12.91-21.67-14.3,2.3-15.68-22.6-1.39-31.82-8.76-3.69,3.69-14.29,3.69-14.29l2.77-15.22,5.07,1.39s-6.82,20.38.46,27.2c11.07,10.37,24.9-12.45,42.65,8.07,8.3-6.46,28.36-1.38,34.12,11.06,11.72,25.32,21.44-33.19,21.44-33.19Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M61.09,103.75a54.37,54.37,0,0,1,9.59-9.16l1.62,20.06a6.92,6.92,0,0,1-2.72,3.9C70,112.44,66.14,106.47,61.09,103.75Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M70.68,94.59s-12.86,9.26-13.83,18c-.69,6.23,12.68,11.3,15.45,2.08"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M78.75,126.41c-1.61,6.22-12.45,7.14-14.52-1.85"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M81.29,120.18a23.52,23.52,0,0,1,15.22,14.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M52.24,114.19s-11.52-2.54-18.21,2.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M121.63,95.05c-1.15-.23-22.36-2.07-28.58-16.83"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M123.48,90.9c-.69,0-14.53,1.62-21.44-9.22"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M121.4,104.51s3.23,3.92,3,7.37"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M132.93,33.5s-2.23,8.85-1,14.91c-6.38-15.14-13.06-23.21-17.21-25.28"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M146.76,79.38c.23,2.76-2.3,5.3-4.38,1.15"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M150.45,75c2.08,1.61,2.54,5.53-.46,5.53"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M143.77,76.84c-.7,2.31-5.54,1.38-3.69-4.15"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M147.92,69.23c1.61,1.16,3,4.61-.7,2.77"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M127,78.69c1.54,4.15-4,6.22-6.3.92"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M115,72.46c0,3.69-7.38,3.23-7.15-2.76"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M126.24,68.08c1.62,4.61-9.22,6-8.29-3"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M24.28,59.29c-2.84,3.47,2.42,7.24,6.4,2.91"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M38.87,57.22c-1.08,3.53,6.87,5.47,8.37-.34"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M28.18,49.39c-3.05,3.89,8,8.71,9.66-.19"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M54,54.45c-2.84,3.47,2.42,7.24,6.4,2.91"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M68.61,52.38C67.53,55.91,75.48,57.85,77,52"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M57.92,44.55c-3.05,3.89,8,8.71,9.66-.19"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M83.76,60.67c-2.84,3.48,2.42,7.24,6.4,2.91"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M98.35,58.61c-1.08,3.52,6.87,5.46,8.37-.35"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M87.66,50.77c-3,3.89,8,8.71,9.66-.19"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M129.47,89.44s-75-29.81-107.74-20.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M97,117.11s-8.6-5.69-15.67-4.92S101,123,97,117.11Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M47.09,104.66c-10.33-4-18.13-2.61-12.91-.46S56.16,108.19,47.09,104.66Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M56.85,180.81s-3.92-.46-4.38-8.06c-2.07,4.38-9.45,10.37-16.37,8.76"
})));

var SvgHead = function SvgHead(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 157.92 184.28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHead, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/head.ef63664f.svg";
export { ForwardRef as ReactComponent };